import { useCallback, useContext, useRef } from 'react';
import api from 'api';
import useUndoActions from 'hooks/useUndoActions';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useTranslation } from 'react-i18next';
import useRefetch from 'hooks/useRefetch';

export default function useTransferDealToEnterpriseColleague(
  dealRoomId: string,
) {
  const { isUndoAvailable, setUndoTimeout, clearUndoTimeout } =
    useUndoActions();

  const { refetchFlag, refetch } = useRefetch();

  const { popSuccess, popServerError } = useContext(PopNotificationsContext);

  const transferredTo = useRef('');

  const { t } = useTranslation();

  const onTransferToEnterpriseColleague = useCallback(
    async (userId: string, userFullName: string) => {
      clearUndoTimeout();
      transferredTo.current = userFullName;

      try {
        await api.dealRoom.transferDealToEnterpriseUser(dealRoomId, userId);

        setUndoTimeout(() => {
          popSuccess(
            t('dealTransferredTo', {
              transferredTo: userFullName,
            }),
          );
          setTimeout(refetch, 2000);
        });

        return { isSuccessfully: true };
      } catch (e) {
        popServerError(e);
        return { isSuccessfully: false };
      }
    },
    [
      clearUndoTimeout,
      dealRoomId,
      setUndoTimeout,
      popSuccess,
      t,
      refetch,
      popServerError,
    ],
  );

  const onUndoTransferToEnterpriseColleague = useCallback(async () => {
    clearUndoTimeout();
    api.dealRoom.undoTransferDealToEnterpriseUser(dealRoomId);
  }, [clearUndoTimeout, dealRoomId]);

  return {
    refetchFlag,
    isUndoTransferToEnterpriseColleagueAvailable: isUndoAvailable,
    transferredTo: transferredTo.current,
    onTransferToEnterpriseColleague,
    onUndoTransferToEnterpriseColleague,
  };
}
